import { formatNumber, type NumberFormatVariant } from "@msuite/utils/numbers";
import { weightNumberFields } from "@msuite/utils/schemas";
import { createColumnHelper } from "../data-table/column-helper";
import { localized } from "../../localization";

/**
 * The weight columns, built for whatever row type the table actually uses —
 * a factory for the same reason `sizeColumns` is one.
 */
/** The shape the weight cells actually read. */
type WeightColumnRow = Partial<Record<(typeof weightNumberFields)[number], number | null>> & {
	weightUnit?: string | null;
};

export function weightColumns<T extends WeightColumnRow>() {
	const columnHelper = createColumnHelper<T>();

	return [
		...weightNumberFields.map((field) =>
			columnHelper.accessor((row) => row[field], {
				id: field,
				header: localized(`calculations.${field}`),
				cell: (cell) =>
					// The unit column is the database's full `unit` enum, which is wider
					// than the formatter's variants; anything it does not know falls
					// through to the default formatting.
					formatNumber(cell.getValue(), cell.row.original.weightUnit as NumberFormatVariant),
			}),
		),
	];
}
